import React, { useEffect, useRef, useState } from "react";

import CommonMuiTable, { Table } from "../../Component/Table/Table";
import { call, delete_icon, edit_icon, okiee } from "../../assets/img";

import DateRange2 from "../../Component/DateRange/DateRange2";
import { get, post } from "../../Services/ApiHandler";
import { ICON_FILTER, URLS } from "../../Services/Constant";
import { Toast } from "../../Component/Toast";
import useStoreKv from "../redux/store/useStorekv";
import moment from "moment";
import CustomScroll from "../../Component/CustomScroll";
import { useLocation } from "react-router-dom";
import SubmitButton from "../../Component/SubmitButton";
import { MaskIcon } from "../../Component/MaskIcon";

const WithdrawHistory = () => {

  const [page, setPage] = useState(1);
  const [totalRecharge, setTotalRecharge] = useState(0);

  const [loader, setLoader] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [errors, setErrors] = useState({});
  const [mobile, setMobile] = useState("");
  const [search, setSearch] = useState('');

  const [popup, setPopup] = useState(false);
  const [block_reason, setBlock_reason] = useState('');
  const [selectedDate, setSelectedDate] = useState();
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const lastRequestId = useRef(0);
  const [idd, setIdd] = useState(null);
  const [totalUser, setTotalUser] = useState(0);
  const [pagecount, setPagecount] = useState();
  const [pendingList, setPendingList] = useState(false);
  const [loadingId, setLoadingId] = useState(null);
  const [isApprove, setIsApprove] = useState(null);
  const [pendingLoad, setPendingLoad] = useState(false);
  const [searchLoad, setSearchLoad] = useState(false);
  const [hiddenIds, setHiddenIds] = useState([]);
  const [showWithdrawTotal, setShowWithdrawTotal] = useState(false);
  const { kv, set } = useStoreKv();
  const withdrawHistory = kv.withdrawhistory || [];

  const [owners, setOwners] = useState(withdrawHistory);

  const location = useLocation();
  const scrollRef = useRef(null);
  const clientId = location?.state?.clientId; // adjust key if different
const [totalWithdrawAmount, setTotalWithdrawAmount] = useState(0);

const getClientTotalWithdraw = async (clientId) => {
  try {
    const res = await get(`${URLS.CLIENT}/wallet/withdraw/total-withdraw/${clientId}`);
    if (res?.status === "success") {
      setTotalRecharge(res?.data?.total_withdraw ?? res?.total_withdraw ?? 0);
    }
  } catch (err) {
    console.error("Error fetching total withdraw:", err);
  }
};



  useEffect(() => {
    const fromFooter = location.state?.fromFooter;

    if (fromFooter) {
      if (location.state?.fromFooter) {
        setTimeout(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }, 0);
        getList();
      }
    }
  }, [location]);

  const getList = async (page = 1, filters = [], currentRequestId) => {

    if (!kv.withdrawhistory || kv.withdrawhistory.length === 0) {
      setLoading1(true);
    }
    let pending;
    if (pendingList) {
      pending = `status=1`
    } else {
      pending = `status=`
    }

    try {
      const query = filters.length ? `&${filters.join("&")}` : "";
      const res = await get(`${URLS.CLIENT}/wallet/withdraw?page=${page}${query}&${pending}`);

      if (currentRequestId !== lastRequestId.current) return;

      console.log("res withdraw history list", res);

      if (res?.status === "success") {
        const list = res?.data || [];
        setOwners(list);
        set('withdrawhistory', list);
        setTotalUser(res?.pagination?.total_count);
        setPagecount(res?.pagination?.total_pages);
        setTotalWithdrawAmount(res.total_withdraw_amount)
        setLoading1(false);
        if (search && list.length > 0 && list[0]?.client_id) {
          getClientTotalWithdraw(list[0]?.client_id);
          setShowWithdrawTotal(true);
        }
      } else {
        setOwners([]);
        set('withdrawhistory', []);
        setLoading1(false);
        setSearchLoad(false);
            setShowWithdrawTotal(false);

      }
    } catch (error) {
      if (currentRequestId !== lastRequestId.current) return;
      console.error("Error fetching client list:", error);
      setLoading1(false)
      setOwners([]);
    }
  };

  useEffect(() => {
    const currentRequestId = ++lastRequestId.current;

    let filters = [];
    if (search) filters.push(`mobile=${encodeURIComponent(search)}`);
    if (selectedDate)
      filters.push(`date=${encodeURIComponent(selectedDate)}`);

    getList(page, filters, currentRequestId);
  }, [selectedDate, search, page, pendingList]);


  useEffect(() => {
    console.log("idd", idd);
  }, [idd]);

  const handleApprove = async (id) => {
    setLoadingId(id);
    setHiddenIds(prev => [...prev, id]);
    let filters = [];
    const currentRequestId = ++lastRequestId.current;
    if (id) {
      try {
        const res = await post(`${URLS.CLIENT}/wallet/withdraw/approve`, { withdraw_id: id });
        console.log("res", res);
        if (res?.status === "success") {
          setLoadingId(null);
          getList(page, filters, currentRequestId);
          Toast(res.message || 'Response successfully');
        }
      } catch (err) {
        console.log("err", err);
      }
    }
  };


  useEffect(() => {
    if (!search) {
      setTotalRecharge(0);
    }
  }, [search]);


  const handleDelete = async () => {
    const filters = [];
    const currentRequestId = ++lastRequestId.current;

    if (!idd) return;

    setLoading(true);

    try {

      // 👉 2) IF reject is required
      if (isApprove === "No") {
        const rejectRes = await post(`${URLS.CLIENT}/wallet/withdraw/reject`, { withdraw_id: idd });
        console.log("rejectRes", rejectRes);

        if (rejectRes?.status === "success") {
          Toast(rejectRes.message || "Rejected successfully");
        }
      }


      // 👉 1) DELETE API call
      const deleteRes = await post(`${URLS.CLIENT}/wallet/withdraw/delete`, { id: idd });
      console.log("deleteRes", deleteRes);

      if (deleteRes?.status === "success") {
        Toast(deleteRes.message || "Deleted successfully");
        setDeletePopup(false);
      } else {
        // If delete fails, stop further action
        setDeletePopup(false);
        return;
      }



      // 👉 3) Refresh List
      getList(page, filters, currentRequestId);

    } catch (err) {
      console.log("err", err);
      setDeletePopup(false);

    } finally {
      setLoading(false);
    }
  };



  const handleBlock = async (status) => {

    let filters = [];
    const currentRequestId = ++lastRequestId.current;

    const payload = {
      withdraw_id: block_reason,
    };

    try {
      setLoader(true);

      // const changeStatus = status === 'Blocked' ? 'block' : 'unblock';
      const res = await post(`${URLS.CLIENT}/wallet/withdraw/approve`, payload);

      console.log("Block/unblock success:", res);

      if (res?.status === "success") {
        if (status === 1) {
          setPopup(false);
        }
        getList(page, filters, currentRequestId);
      } else {
        console.error("Failed to change block status:", res);
      }
    } catch (err) {
      console.error("Error during block/unblock:", err);
    } finally {
      setLoader(false);
    }
  };


  const handleSearch = () => {
    if (!mobile) return;
    setSearchLoad(true);
    setLoading1(true);
    setSearch(mobile);
  }

  const truncateText = (text, limit = 16) => {
    if (!text) return '';
    return text.length > limit ? text.substring(0, limit) + '...' : text;
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Action",
        accessor: "action",
        Cell: ({ row }) => {
          const isApproved = row.original.approved === "No";


          return (
             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 20 ,paddingRight:"20px",paddingLeft:"20px"}}>
              {isApproved &&
                !hiddenIds.includes(row.original?.id) && (
                  <button
                    onClick={() => handleApprove(row.original?.id)}
                    className="cust-btn"
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, margin: 0, border: 'none', background: 'none', lineHeight: 1 }}

                  >
                    <MaskIcon src={okiee} width={18} height={18} alt="approved" className="okiee-btn" />
                  </button>
                )}


              {/* {isApproved && (
                      <button onClick={() => handleReject(row.original?.id)} className="cust-btn">
                        <img src={thumdown} alt="approved" className="okiee-btn" />
                      </button>
                    )} */}

              <button onClick={() => {
                setIdd(row.original?.id);
                setDeletePopup(true);
                setIsApprove(row.original.approved);
              }} className="cust-btn"          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, margin: 0, border: 'none', background: 'none', lineHeight: 1 }}
>
                <img src={delete_icon} alt="delete" className="delete-icon" />
              </button>
            </div>
          );
        },
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ value, row }) => {
          const { account_details, ifsc } = row.original;

          return (
            <p className={"text-nowrap ac_item"}>
              ₹&nbsp;{value}
            </p>
          );
        },
      },
      {
        Header: (
          <span>
            ACCOUNT DETAILS
            <br />
            AND UPI ID
          </span>
        ),
        accessor: "account_details",
        Cell: ({ row }) => {
          const { acc_no, ifsc_code, method, upi_id } = row.original;
          return (
            <>
              {method === 'UPI' ? (
                <p className="mb-0 ac_item">{truncateText(upi_id)}</p>
              ) : (
                <div>
                  <p className="mb-0">{truncateText(acc_no)}</p>
                  {ifsc_code && <p className="mt-0">{truncateText(ifsc_code)}</p>}
                </div>
              )}
            </>
          );
        },
      },
      {
        Header: " Mobile No",
        accessor: "mobile",
        Cell: ({ value, row }) => {
          // const { account_details, ifsc } = row.original;

          return (
            <p className={"text-nowrap ac_item"}>{value}</p>
          );
        },
      },
      {
        Header: "Method",
        accessor: "method",
        Cell: ({ value, row }) => {
          // const { account_details, ifsc } = row.original;

          return (
            <p className={"text-nowrap ac_item"}>{value}</p>
          );
        },
      },
      {
        Header: (
          <span>
            Request
            <br />
            Date & Time
          </span>
        ),
        accessor: "date",
        Cell: ({ row }) => {
          const { date, time } = row.original;
          return (
            <div style={{ textAlign: "center" }}>
              <p className="mt-0" >{date || '-'}</p>
              <p style={{ textAlign: "center" }} className="mt-0">{time || '-'}</p>
            </div>
          );
        },
      },
      {
        Header: (
          <span>
            Approved
            <br />
            Date & Time
          </span>
        ),
        accessor: "time",
        Cell: ({ row }) => {
          const { updated_date, updated_time, approved } = row.original;
          return (
            <div style={{ textAlign: "center" }}>
              <p className="mt-0" >{approved === 'Yes' ? updated_date : '-'}</p>
              <p className="mt-0">{approved === 'Yes' ? updated_time : '-'}</p>
            </div>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (

            <button
              onClick={() => {
              }}
              style={{ fontSize: 12, margin: 0 }}
              className={`${value == 1 ? "pending_icon2" : "transferred_icon"
                } border-0 f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13   `}
            >
              {value == 1 ? "Pending" : " Transferred"}
            </button>

          );
        },
      },
    ],
    [loadingId]
  );

  const [browsHeader, setBrowsHeader] = useState(true);

  const maxHeight = useRef(window.visualViewport?.height || window.innerHeight);
  const isFirstRun = useRef(true);

  useEffect(() => {
    const handleResize = () => {
      const visibleHeight = window.visualViewport?.height || window.innerHeight;

      // 🔹 Skip logic on first run
      if (isFirstRun.current) {
        isFirstRun.current = false;
        setBrowsHeader(true);
        return;
      }

      // 🔻 Viewport reduced (keyboard / browser UI)
      if (visibleHeight < maxHeight.current) {
        setBrowsHeader(true);

      }
      // 🔺 Viewport restored
      else {
        maxHeight.current = visibleHeight;
        setBrowsHeader(false);
      }
    };

    window.visualViewport?.addEventListener("resize", handleResize);

    return () => {
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, [browsHeader]);

  return (

    <div style={{
      paddingBottom: 52
    }} className="dashRightView marginScrolls d-flex ac-jb flex-column">
      <CustomScroll ref={scrollRef} height="100vh">
        <div style={{ paddingTop: 0 }} className="container_overalls">
          <div className="d-flex ae-jc recharge_container d-flxChanges w-100 gap-3 col-md-5">

            <button style={{ minHeight: 50 }} onClick={() => {
              setPendingList(!pendingList);
              setPendingLoad(true);
              setLoading1(true);
            }} className="recharge_button sec w-50 f2 fs-xs-14 fs-sm-10 fs-md-14 fs-lg-14 fs-xl-14 fs-xxl-14">
              {(loading1 && pendingLoad) ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "black", padding: 8 }}
                />
              ) : (
                <>
                  Withdraw <br />
                  Pending List
                </>
              )}
            </button>
            <div className="w-50 ">
              <p className="f2 my-1 pt-3  fs-xs-14 fs-sm-10 fs-md-14 fs-lg-16 fs-xl-16 fs-xxl-16 text-center " style={{colour :"black"}}>
                {`${selectedDate ? (moment(selectedDate).isSame(moment(), 'day') ? 'Today' : moment(selectedDate).format("DD-MM-YYYY")) : 'Today'} Total Withdraw`}
              </p>
              <button className="recharge_button1 w-100 f3 fs-xs-14 fs-sm-10 fs-md-14 fs-lg-14 fs-xl-14 fs-xxl-14 ">
                ₹ {totalWithdrawAmount}
              </button>
            </div>
          </div>

          <div className="announcement_date mb-3 col-md-5">
            <DateRange2 selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
          </div>
          <div className="form-group col-md-5 text-start my-3">
            <div className="d-flex ac-js">
              <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">
                Mobile Number</label>
            </div>
            <div className="login-input1 mt-1">

              <input
                value={mobile}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 14) {
                    setMobile(value);
                    if (!value) {
                      setSearch("");
                      setTotalRecharge(0);
                      setShowWithdrawTotal(false);
                    }
                  }
                }}
                type="tel"
                placeholder="Search with mobile number"
                required
                maxLength={14}
                className="placholdercolorchanges2"
              />

              <MaskIcon src={call} alt="call icon" style={{ marginRight: 12, width: 20, top: 1, position: 'relative' ,filter: ICON_FILTER }} />
            </div>
            {errors.mobile && <p className="err">{errors.mobile}</p>}
          </div>

          <div className="col-md-5 my-3">
            {/* <button onClick={handleSearch} className="add-button f3 w-100 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white">
              {(loading1 && searchLoad) ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white", padding: 8 }}
                />
              ) : (
                <>
                  Search
                </>
              )}
            </button> */}
            <SubmitButton
              onClick={handleSearch}
              disabled={loading1 || searchLoad}
              title="Search"
            />
          </div>

          <Table
            columns={columns}
            pageno={page}
            setPageno={setPage}
            pagecount={pagecount}
            totalPages={totalUser}
            data={owners}
            showWithdrawTotal={showWithdrawTotal}
            totalWithdraw={totalRecharge}
            show={true}
            loading={loading1}
          />
        </div>
        {popup && (
          <div className="img-popup-design1">
            <div className="img-popup1">
              <button className="close-btn" onClick={() => setPopup(false)}>
                ×
              </button>

              <textarea
                className="input-box3"
                name="reason"
                placeholder="Type your reason here..."
                rows="4"
              />

              <div className="d-flex ac-jc px-1 py-1">
                <button
                  disabled={!block_reason}
                  onClick={() => setPopup(false)}
                  className="add-button w-100 f2 w-45 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                >
                  Block User
                </button>
              </div>
            </div>
          </div>
        )}

        {deletePopup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                Are you sure, you want to delete?
              </p>
              <div className="d-flex ac-jb px-2 mt-4 f3 fs-xs-14 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                <button onClick={() => setDeletePopup(false)} className="no-btn w-40">
                  No
                </button>
                <button
                  onClick={handleDelete}
                  className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                >
                  {loading ? <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "black", padding: 6 }}
                    ></span>
                  </> : "Yes"}
                </button>
              </div>
            </div>
          </div>
        )}
      </CustomScroll>
    </div>
  );
};
export default WithdrawHistory;
